import React, { useEffect, useState } from 'react';
import {
  Checkbox,
  createStyles,
  isWidthDown,
  makeStyles,
  Theme,
  withStyles
} from '@material-ui/core';
import { TPicture } from '../../types/cloudStorage/CloudFileList';
import { PictureImage } from '../parts/cloudStorage/PictureImage';
import { formatDatetime } from '../../utils/common';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';

type Tprops = {
  picture: TPicture;
  handleSelectedPictures: (picture: TPicture) => void;
  setOpenDetailModal: React.Dispatch<React.SetStateAction<boolean>>;
  setPictureId: React.Dispatch<React.SetStateAction<number | undefined>>;
  openDetailModal: boolean;
  selectedPictures: TPicture[];
  openAccordion: boolean;
};

export const FileList: React.FC<Tprops> = (props: Tprops) => {
  const {
    picture,
    handleSelectedPictures,
    setOpenDetailModal,
    setPictureId,
    openDetailModal,
    selectedPictures,
    openAccordion
  } = props;

  // スタイル読み込み
  const classes = useStyles();

  const [value, setValue] = useState<boolean>(false);

  useEffect(() => {}, [selectedPictures]);

  const handleCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    // 親コンポーネントにあるselectedFileIdsを更新する
    handleSelectedPictures(picture);
  };

  // サイズ調整
  const theme = useTheme();
  const isWideScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <div key={picture.id} style={{ margin: '8px 5px', position: 'relative' }}>
      <PictureCheckbox
        checked={
          selectedPictures.find(selectedFile => selectedFile.id == picture.id)
            ? true
            : false
        }
        onChange={handleCheck}
        color='default'
        size='small'
        style={{ position: 'absolute', top: 5, left: 5 }}
      />
      <div>
        <PictureImage
          picture={picture}
          setPictureId={setPictureId}
          openDetailModal={openDetailModal}
          setOpenDetailModal={setOpenDetailModal}
          src={picture.src}
        />
      </div>
      <div className={classes.date}>
        {formatDatetime(
          new Date(picture.created_at),
          'YYYY/MM/DD',
          '日本標準時'
        )}
      </div>
    </div>
  );
};

// 要調整
const PictureCheckbox = withStyles({
  root: {
    backgroundColor: '#fff'
  },
  checked: {}
})(Checkbox);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    date: {
      fontSize: '14px',
      color: '#999',
      fontFamily: 'NotoSans-Display'
    }
  })
);
